module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideBar"
  }, [_c('el-scrollbar', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.activeMenu,
      "unique-opened": false,
      "collapse-transition": false,
      "background-color": "#fff",
      "text-color": "#222222",
      "active-text-color": "#1479FF",
      "mode": "vertical"
    }
  }, _vm._l((_vm.permission_routes), function(item) {
    return _c('sidebar-item', {
      key: item.path,
      attrs: {
        "item": item,
        "basePath": item.path
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8da681c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/sideBar/index.vue
// module id = 455
// module chunks = 24